import { Button, List, ListItem, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { dateTime } from '../../lib/format';
import { useTenantScope } from '../../store/selectors';
import { SectionCard } from '../../ui/primitives';

export default function RecentActivityPanel() {
  const scope = useTenantScope();
  return (
    <SectionCard
      title="Recent activity"
      subtitle="Every registry action is written to an immutable audit trail"
      action={
        <Button component={RouterLink} to="/manager/audit" size="small">
          View all
        </Button>
      }
      noPadding
    >
      <List dense disablePadding>
        {scope.audit.slice(0, 8).map((event) => (
          <ListItem key={event.id} sx={{ px: 2.5, borderTop: '1px solid', borderColor: 'divider' }}>
            <ListItemText
              primary={
                <>
                  <Typography component="span" variant="body2" sx={{ fontWeight: 600 }}>
                    {event.action}
                  </Typography>
                  <Typography component="span" variant="body2" color="text.secondary">
                    {' '}
                    · {event.target}
                  </Typography>
                </>
              }
              secondary={`${event.actor} · ${dateTime(event.at)} · ${event.detail}`}
            />
          </ListItem>
        ))}
      </List>
    </SectionCard>
  );
}
